import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

/**
 * Heading showing the subject's participant ID at the exact horizontal center of the page.
 * Uses absolute positioning (parent must have position: relative) so it stays centered
 * regardless of Back button or action buttons on the sides.
 */
const SubjectParticipantIdHeading = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const participantId = useSelector((state) => state.subject?.details?.participantId);
  const subjectNumber = useSelector((state) => state.subject?.details?.subjectNumber);
  const tempParticipantId = useSelector((state) => state.subject?.tempParticipantId);
  const { subjectMasterId } = useParams();

  const displayParticipantId = subjectMasterId ? (participantId || subjectNumber || '-') : (tempParticipantId || '-');
  const hideHeading = !subjectMasterId && (tempParticipantId == null || tempParticipantId === '');
  if (hideHeading) {
    return <></>;
  }

  const fullHeadingText = subjectNumber
    ? `Subject Number: ${subjectNumber}`
    : `Participant ID: ${displayParticipantId}`;
  const mobileHeadingText = subjectNumber
    ? `S#: ${subjectNumber}`
    : displayParticipantId;

  return (
    <Box
      sx={{
        position: 'absolute',
        left: '50%',
        transform: 'translateX(-50%)',
        top: -5,
        bottom: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        pointerEvents: 'none',
        maxWidth: { xs: 'calc(100% - 96px)', sm: 'calc(100% - 140px)', md: 'none' },
        px: { xs: 0.5, md: 0 },
      }}
    >
      <Typography
        variant="h6"
        component="h1"
        noWrap
        title={fullHeadingText}
        sx={{
          fontSize: { xs: '1rem', sm: '1rem', md: '1.25rem' },
          textAlign: 'center',
        }}
      >
        {isMobile ? mobileHeadingText : fullHeadingText}
      </Typography>
    </Box>
  );
};

export default SubjectParticipantIdHeading;
